import {IStatisticsApi} from '@/features/statistics/IStatisticsApi';
import {AxiosInstance} from 'axios';
import {inject, injectable} from 'inversify-props';
import {IAppConfig, IAppConfigId} from '@/features/shared/IAppConfig';
import {AxiosId} from '@/plugins/axios';

@injectable()
export default class StatisticsApi implements IStatisticsApi {
    @inject(IAppConfigId)
    config!: IAppConfig;

    @inject(AxiosId)
    axios!: AxiosInstance;

    getMpcStatistics(calendarDay?: string): Promise<any[]> {
        return new Promise((resolve, reject) => {
            this.axios
                .get<any>('/api/mpcapi/getmpcstatistics', {
                    params: {
                        calendarDay,
                        token: this.config.token
                    }
                })
                .then(response => resolve(response as any))
                .catch(exception => reject(exception));
        });
    }

    async getMpcStatisticsByDayLineDeparture(from: string, to: string): Promise<any> {
        return await this.axios.get<any>('/api/mpcapi/getmpcstatisticsbydaylinedeparture', {
            params: {
                from,
                to,
                token: this.config.token
            }
        });
    }

    getExportUrl(from: string, to: string): string {
        const params = new URLSearchParams({
            from,
            to,
            token: this.config.token ?? ''
        });
        return `/api/mpcapi/exportmpcstatistics?${params.toString()}`;
    }
}
